<template>
    <div id="konfigurator-fotografie">

        <h1>Profilový obrázek psa<br>(bude i na obalu krmiva)</h1>

        <div class="form-content">
            <div v-show="!mazlicek.fotografie.value" style="max-width: 800px" class="form-group icn-img-wrapper">
                <div>
                    <img v-bind:src="mazlicek.fotografie.icnValue"/>
                </div>
            </div>
            <div v-show="mazlicek.fotografie.value" style="max-width: 1000px" class="form-group crop-img-wrapper">
                <a class="close" @click="nechciFotoClick">X</a>
                <div>
                    <!--<vue-cropper-->
                    <!--ref="cropper"-->
                    <!--:guides="true"-->
                    <!--:aspect-ratio="1"-->
                    <!--:min-crop-box-width="600"-->
                    <!--:min-crop-box-height="600"-->
                    <!--:view-mode="4"-->
                    <!--drag-mode="crop"-->
                    <!--:src="mazlicek.fotografie.value"-->
                    <!--alt="Source Image"-->
                    <!--:cropmove="cropImage">-->
                    <!--</vue-cropper>-->
                    <vue-croppie
                            ref=croppieRef
                            :enableResize=false
                    :viewport="{width: viewportSize, height: viewportSize, type: 'square'}"
                    :boundary="{width: boundarySize, height: boundarySize}"
                    >
                    </vue-croppie>
                </div>
            </div>
            <div v-if="!mazlicek.fotografie.value" class="fotografie-nahrat">
                <label for="file-upload-photo"><span class="button">Nahrajte vlastní fotku (nepovinné)</span></label>
                <input ref="photoInput" type="file" @change="setImage" id="file-upload-photo">
            </div>
        </div>

        <info :krok="3"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import navigace from './Navigace'
    import info from './Info'
    import VueCropper from 'vue-cropperjs'
    import {apiSilex} from '../api'
    import imageService from '../services/image-service'
    import {apiDrupal} from '../api/index'

    export default {
        name: 'fotografie',
        components: {navigace, info, 'vue-cropper': VueCropper},
        mixins: [validationMixin],
        data: function () {
            return {
                photo: '',
                mazlicek: this.$store.state.mazlicek,
                dummyIco: 'https://dummyimage.com/600x400/000/fff&amp;text=ico',
                cropImage: null,
                rasaItems: null,
                enRasaName: null,
                imgChanged: null,
                url: null,
                cropOptions: null
            }
        },
        computed: {
            boundarySize: function () {
                let paddingHorizontal = 45
                return window.innerWidth < 600 ? window.innerWidth - 2 * paddingHorizontal : 600
            },
            viewportSize: function () {
                let padding = 20
                return window.innerWidth < 600 ? this.boundarySize - 2 * padding : 400
            },
        },
        methods: {
            obrazekTyp: function (val) {
                this.mazlicek.fotografie.value = null
            },
            nechciFotoClick: function (e) {
                this.mazlicek.fotografie.typ = 'ikona'
                this.mazlicek.fotografie.value = ''
                this.mazlicek.fotografie.original = ''
                this.mazlicek.fotografie.cropOptions = null
                this.$refs.photoInput.value = null
            },
            prev: function () {
                this.$router.push({name: 'rasa'})
            },
            next: function () {
                if (this.mazlicek.fotografie.typ === 'foto') {
                    let options = {
                        type: 'base64',
                        size: 'viewport',
                        format: 'jpeg',
                        quality: 1,
                        circle: 'false'
                    }
                    this.$refs.croppieRef.get((param) => {
                        this.$refs.croppieRef.setZoom(param.zoom + 0.01)
                    })
                    this.$refs.croppieRef.result(options, (output) => {
                        this.mazlicek.fotografie.value = output
                        this.mazlicek.fotografie.url = this.url
                        this.cropOptions = this.$refs.croppieRef.get()
                        this.mazlicek.fotografie.cropOptions = this.cropOptions
                        this.mazlicek.fotografie.imgCropComplete = true
                        this.updatePet()
                    })
                } else {
                    apiDrupal.get('/pet-remove-img/' + this.mazlicek.nid).then(response => {
                        this.mazlicek.fotografie.value = ''
                        this.mazlicek.fotografie.original = ''
                        this.mazlicek.fotografie.cropOptions = null
                        this.mazlicek.fotografie.url = null
                        this.mazlicek.fotografie.typ = 'ikona'

                        this.updatePet()
                    })
                }
            },
            saveAndQuit : function() {
              if (this.mazlicek.fotografie.typ === 'foto') {
                let options = {
                  type: 'base64',
                  size: 'viewport',
                  format: 'jpeg',
                  quality: 1,
                  circle: 'false'
                }
                this.$refs.croppieRef.get((param) => {
                  this.$refs.croppieRef.setZoom(param.zoom + 0.01)
                })
                this.$refs.croppieRef.result(options, (output) => {
                  this.mazlicek.fotografie.value = output
                  this.mazlicek.fotografie.url = this.url
                  this.cropOptions = this.$refs.croppieRef.get()
                  this.mazlicek.fotografie.cropOptions = this.cropOptions
                  this.mazlicek.fotografie.imgCropComplete = true
                  this.mazlicek.fotografie.valid = true
                  this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                      this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                    }, error => {
                      console.error(error)
                    })
                })
              } else {
                apiDrupal.get('/pet-remove-img/' + this.mazlicek.nid).then(response => {
                  this.mazlicek.fotografie.value = ''
                  this.mazlicek.fotografie.original = ''
                  this.mazlicek.fotografie.cropOptions = null
                  this.mazlicek.fotografie.url = null
                  this.mazlicek.fotografie.typ = 'ikona'

                  this.mazlicek.fotografie.valid = true
                  this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                      this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                    }, error => {
                      console.error(error)
                    })
                })
              }
            },
            setImage(e) {
                this.mazlicek.fotografie.imgCropComplete = false
                this.url = URL.createObjectURL(e.target.files[0])
                this.$refs.croppieRef.refresh()
                this.$nextTick(() => {
                    this.$refs.croppieRef.bind({
                        url: this.url
                    });
                })

                const file = e.target.files[0]
                if (!file.type.includes('image/')) {
                    this.$refs.photoInput.value = null
                    alert('Vybraný soubor musí být obrázek')
                    return
                }

                if (typeof FileReader === 'function') {
                    const reader = new FileReader()
                    const _that = this

                    reader.onload = (event) => {

                        let image = new Image()

                        image.addEventListener('load', () => {

                            if (image.width < 650 || image.height < 450) {
                                this.$refs.photoInput.value = null
                                alert('Obrázek musí mít rozlišení nejméně 650 x 450')
                                return
                            }
                            // this.nechciIkonuMamFotoClick()
                            this.mazlicek.fotografie.typ = 'foto'
                            this.mazlicek.fotografie.value = event.target.result
                            this.mazlicek.fotografie.original = event.target.result
                            // rebuild cropperjs with the updated source
                            // this.$refs.cropper.replace(event.target.result)
                        })

                        image.src = event.target.result
                    }

                    reader.readAsDataURL(file)
                } else {
                    alert('Sorry, FileReader API not supported')
                }
            },
            afterMounted() {

                this.mazlicek.step.current = 3
                this.$cookies.set('lastVisitedStep', 3)
                jQuery('html, body').animate({scrollTop: 0}, '500')

                if (this.mazlicek.fotografie.url) {
                    this.url = this.mazlicek.fotografie.url
                    this.cropOptions = this.mazlicek.fotografie.cropOptions
                    this.$refs.croppieRef.bind({
                        url: this.url,
                        points: this.cropOptions.points,
                        zoom: this.cropOptions.zoom
                    });
                }
                if (this.mazlicek.rasa.id) {
                    apiSilex.get('/rasa?id=' + this.mazlicek.rasa.id).then((response) => {
                        const val = response.data[0]
                        const _that = this
                        const raceImage = imageService.RACE_ORIGINAL_IMAGES_URL + val.title_en + '.png'

                        var xhr = new XMLHttpRequest()

                        xhr.onload = function () {
                            imageService
                                .createBase64Image(xhr.response)
                                .then(base64Image => {
                                    _that.mazlicek.fotografie.icnValue = base64Image
                                })
                        }
                        xhr.open('GET', raceImage)
                        xhr.responseType = 'blob'
                        xhr.send()
                    })
                } else if(this.mazlicek.rasa.velikost) {
                    const _that = this
                    // const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-' + this.mazlicek.rasa.velikost + '.png'

                    const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-new-' + this.mazlicek.rasa.velikost + '.svg'

                    var xhr = new XMLHttpRequest()

                    xhr.onload = function () {
                        imageService
                            .createBase64Image(xhr.response)
                            .then(base64Image => {
                                _that.mazlicek.fotografie.icnValue = base64Image
                            })
                    }
                    xhr.open('GET', raceImage)
                    xhr.responseType = 'blob'
                    xhr.send()
                }
            },
            updatePet() {
                this.mazlicek.fotografie.valid = true
                this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                        this.$router.push({name: 'narozeniny'})
                    }, error => {
                        console.error(error)
                    })
            }
        },
        mounted: function () {
            this.afterMounted()
        },
        watch: {
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (val.value)
                        this.afterMounted()
                }
            },
            'mazlicek.fotografie.value': {
                deep: true,
                handler: function (val) {
//                    this.$refs.croppieRef.bind({
//                        url: 'http://i.imgur.com/miVkBH2.jpg',
//                    });
                }
            },
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
//                    console.log(this.url)
                    if (this.mazlicek.fotografie.url) {
                        this.url = this.mazlicek.fotografie.url
                        this.cropOptions = this.mazlicek.fotografie.cropOptions
                        this.$refs.croppieRef.bind({
                            url: this.url,
                            points: this.cropOptions.points,
                            zoom: this.cropOptions.zoom
                        });
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 03Fotografie.vue?6124c346